import { Link } from "react-router-dom";
import { Send, MessageCircle, Phone, Instagram, Facebook } from "lucide-react";
import { CONTACT, COMPANY } from "../data";
import { useLang } from "../LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src={CONTACT.logo}
                alt=""
                data-testid="footer-logo-image"
                className="w-10 h-10 object-contain bg-white rounded-sm p-0.5"
                onError={(event) => { event.currentTarget.style.display = "none"; }}
              />
              <span className="font-display font-bold text-white text-lg">DRON</span>
            </div>
            <p className="text-sm text-[#A3A3A3] max-w-sm leading-relaxed">{t.footer.tagline}</p>
            <div className="flex gap-3 mt-6">
              {[
                { icon: Send, href: CONTACT.telegram, label: "Telegram" },
                { icon: MessageCircle, href: CONTACT.whatsapp, label: "WhatsApp" },
                { icon: Instagram, href: CONTACT.instagram, label: "Instagram" },
                { icon: Facebook, href: CONTACT.facebook, label: "Facebook" },
              ].map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href || undefined}
                  target={href ? "_blank" : undefined}
                  rel={href ? "noopener noreferrer" : undefined}
                  aria-label={label}
                  aria-disabled={!href || undefined}
                  tabIndex={href ? undefined : -1}
                  data-testid={`social-${label.toLowerCase()}`}
                  onClick={(event) => { if (!href) event.preventDefault(); }}
                  className={`grid place-items-center w-10 h-10 border border-white/15 rounded-sm text-white/70 transition-colors ${href ? "hover:text-white hover:border-[#E02020] hover:bg-[#E02020]/10" : "opacity-50 cursor-not-allowed"}`}
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">{t.footer.contact}</h4>
            <ul className="space-y-3 text-sm text-[#A3A3A3]">
              <li>
                <a href={CONTACT.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors">
                  <Phone size={15} className="text-[#E02020]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={CONTACT.telegram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors">
                  <Send size={15} className="text-[#E02020]" /> Telegram
                </a>
              </li>
              <li>
                <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors">
                  <MessageCircle size={15} className="text-[#E02020]" /> WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">{t.footer.company}</h4>
            <ul className="space-y-2 text-sm text-[#A3A3A3] leading-relaxed">
              <li>{COMPANY.name}</li>
              <li>NIP: {COMPANY.nip}</li>
              <li>REGON: {COMPANY.regon}</li>
              <li>KRS: {COMPANY.krs}</li>
              <li>{COMPANY.address}</li>
              <li>{COMPANY.city}</li>
              <li>
                <Link to="/polityka-prywatnosci" data-testid="footer-privacy" className="underline underline-offset-2 hover:text-white">
                  {t.footer.privacy}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© 2025 {COMPANY.name} {t.footer.rights}</span>
          <span>dron.voxianet.com</span>
        </div>
      </div>
    </footer>
  );
};
